import { useMutation } from '@tanstack/react-query';

import { useAppDispatch } from '@/store/hooks';
import {
  setTripTokenError,
  setTripTokenFulfilled,
  setTripTokenPending
} from '@/store/slices/tripToken.slice';

import { loginApi } from './login.api';

export const useLoginTrip = () => {
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: loginApi.fetchTripToken,
    onMutate: () => {
      dispatch(setTripTokenPending());
    },
    onSuccess: data => {
      dispatch(setTripTokenFulfilled(data));
    },
    onError: err => {
      dispatch(setTripTokenError(err));
    }
  });
};
